import { MODAL, ACCOUNT } from '../../reduxs'

const initialState = {
  status: null,
  confirm: false,
  create: false,
  validate: null,
  isOpenCrashMeetingModal: false,
  isOpenBookingDetailModal: false,
  isOpenBookingMoreDetailModal: false,
  isOpenModalCrashBooking: false,
  isOpenModalInformation: false,
  orderModal: {
    isOpenOrderCounterModal: false,
    isOpenConfirmOrderModal: false,
    isOpenSuccessOrderModal: false,
    isOpenCancelOrderModal: false,
    isOpenErrorOrderModal: false,
  },
  issueModal: {
    isOpenIssueReportModal: false,
    isOpenIssueFileLimitModal: false,
  },
  isOpenExtendMeetingModal: false,
  errorModal: {
    isOpenErrorModal: false,
    textModal: null
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case MODAL.actionType.SHOW_VALIDATE :
      return { ...state, validate: action.validate.data || action.validate }
    case MODAL.actionType.CLEAR_VALIDATE :
      return { ...state, validate: initialState.validate }

    case MODAL.actionType.OPEN_MODAL_STATUS :
      return { ...state, status: action.status }
    case MODAL.actionType.CLOSE_MODAL_STATUS :
      return { ...state, status: initialState.status }

    case MODAL.actionType.OPEN_MODAL_CONFIRM :
      return { ...state, confirm: true }
    case MODAL.actionType.CLOSE_MODAL_CONFIRM :
      return { ...state, confirm: initialState.confirm, validate: initialState.validate }

    case MODAL.actionType.OPEN_MODAL_CREATE:
      return { ...state, create: true }
    case MODAL.actionType.CLOSE_MODAL_CREATE :
      return { ...state, create: initialState.create, validate: initialState.validate }

    case MODAL.actionType.CLEAR_DATA_MODAL :
      return { ...initialState }

    case ACCOUNT.actionType.CLEAR_ALL_DATA:
      return { ...initialState }

    case MODAL.actionType.OPEN_CRASH_MEETING_MODAL:
      return { ...state, isOpenCrashMeetingModal: true }

    case MODAL.actionType.CLOSE_CRASH_MEETING_MODAL:
      return { ...state, isOpenCrashMeetingModal: false }

    case MODAL.actionType.OPEN_BOOKING_DETAIL_MODAL:
      return { ...state, isOpenBookingDetailModal: true }

    case MODAL.actionType.CLOSE_BOOKING_DETAIL_MODAL:
      return { ...state, isOpenBookingDetailModal: false }

    case MODAL.actionType.OPEN_BOOKING_MORE_DETAIL_MODAL:
      return { ...state, isOpenBookingMoreDetailModal: true }

    case MODAL.actionType.CLOSE_BOOKING_MORE_DETAIL_MODAL:
      return { ...state, isOpenBookingMoreDetailModal: false }

    case MODAL.actionType.OPEN_MODAL_CRASH_BOOKING:
      return { ...state, isOpenModalCrashBooking: true }

    case MODAL.actionType.CLOSE_MODAL_CRASH_BOOKING:
      return { ...state, isOpenModalCrashBooking: false }

    case MODAL.actionType.OPEN_MODAL_INFORMATION:
      return { ...state, isOpenModalInformation: true }

    case MODAL.actionType.CLOSE_MODAL_INFORMATION:
      return { ...state, isOpenModalInformation: false }

    case MODAL.actionType.SET_ORDER_COUNTER_MODAL:
      return {
        ...state,
        orderModal: {
          ...state.orderModal,
          isOpenOrderCounterModal: action.data.isOpenOrderCounterModal,
        }
      }

    case MODAL.actionType.SET_CONFIRM_ORDER_MODAL:
      return {
        ...state,
        orderModal: {
          ...state.orderModal,
          isOpenConfirmOrderModal: action.data.isOpenConfirmOrderModal,
        }
      }

    case MODAL.actionType.SET_SUCCESS_ORDER_MODAL:
      return {
        ...state,
        orderModal: {
          ...state.orderModal,
          isOpenSuccessOrderModal: action.data.isOpenSuccessOrderModal,
        }
      }

    case MODAL.actionType.SET_CANCEL_ORDER_MODAL:
      return {
        ...state,
        orderModal: {
          ...state.orderModal,
          isOpenCancelOrderModal: action.data.isOpenCancelOrderModal,
        }
      }

    case MODAL.actionType.SET_ERROR_ORDER_MODAL:
      return {
        ...state,
        orderModal: {
          ...state.orderModal,
          isOpenErrorOrderModal: action.data.isOpenErrorOrderModal,
        }
      }

    case MODAL.actionType.SET_ISSUE_REPORT_MODAL:
      return {
        ...state,
        issueModal: {
          ...state.issueModal,
          isOpenIssueReportModal: action.data.isOpenIssueReportModal,
        }
      }

    case MODAL.actionType.SET_ISSUE_FILE_LIMIT_MODAL:
      return {
        ...state,
        issueModal: {
          ...state.issueModal,
          isOpenIssueFileLimitModal: action.data.isOpenIssueFileLimitModal,
        }
      }

    case MODAL.actionType.OPEN_EXTEND_MEETING_MODAL:
      return { ...state, isOpenExtendMeetingModal: true }

    case MODAL.actionType.CLOSE_EXTEND_MEETING_MODAL:
      return { ...state, isOpenExtendMeetingModal: false }

    case MODAL.actionType.SET_ERROR_MODAL:
      return { 
        ...state,
        errorModal: {
          isOpenErrorModal: action.data.isOpenErrorModal,
          textModal: action.data.textModal,
        } 
      }

    default :
      return state
  }
}
